import type { FC, MouseEventHandler, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { buildMailtoUrl } from '@app/utils/helpers';
import { Namespace } from '@data';

interface MailtoLinkProps {
  bodyKey?: string;
  children?: ReactNode;
  className?: string;
  email: string;
  ns?: Namespace;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  subjectKey?: string;
}

export const MailtoLink: FC<MailtoLinkProps> = ({
  email,
  subjectKey,
  bodyKey,
  className = '',
  children,
  ns = Namespace.ADMIN,
  onClick,
}) => {
  const { t } = useTranslation([ns]);

  const subject = subjectKey ? t(subjectKey) : undefined;
  const body = bodyKey ? t(bodyKey) : undefined;

  const href = buildMailtoUrl(email, subject, body);

  return (
    <a href={href} className={className} onClick={onClick}>
      {children}
    </a>
  );
};
